const middleware = {}

middleware['initClient'] = require('../middleware/initClient.js')
middleware['initClient'] = middleware['initClient'].default || middleware['initClient']

middleware['permissions'] = require('../middleware/permissions.js')
middleware['permissions'] = middleware['permissions'].default || middleware['permissions']

export default middleware
